import LoyaltyDashboard from 'pages/loyalty/loyalty-dashboard/loyalty-dashboard';
import { routes } from 'utils/routing';

export const rootScreenProps = {
  name: routes.loyaltyRewardsDashboard,
  component: LoyaltyDashboard,
};
